window.addEventListener('DOMContentLoaded', () => {
    let cookie = document.cookie;
    let key = 'items=';
    let keyIndex = -1;
    if (keyIndex = cookie.indexOf('items=')) {
        let itemValue = cookie.substr(keyIndex + key.length);
        itemValue = itemValue.substr(0, itemValue.indexOf('|')).trim();

        if (itemValue) {
            let indicator = document.querySelector('#cart-count');
            if (indicator) {
                indicator.classList.add('menu__shoppingcart-count--active');
                indicator.innerText = itemValue;
            }
        }

    }
});